/**
 * Hook TanStack Query per il dominio CVE globale.
 * Pattern identico a features/products/hooks.ts (slice 1).
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchCveDetail, fetchGlobalCves } from './api.js';
import type { CveDetail, GlobalCveEntry } from './types.js';

/** Chiavi query centralizzate per il dominio CVE. */
export const cveKeys = {
  all: ['cve'] as const,
  lista: () => ['cve', 'lista'] as const,
  detail: (cveId: string) => ['cve', 'detail', cveId] as const,
} as const;

/**
 * Recupera la lista globale di tutte le CVE.
 * Aggrega il risultato dal snapshot più recente per release.
 */
export function useGlobalCves(): UseQueryResult<GlobalCveEntry[]> {
  return useQuery({
    queryKey: cveKeys.lista(),
    queryFn: fetchGlobalCves,
  });
}

/**
 * Recupera il dettaglio di una CVE con elenco release affette e stato VEX per-release.
 * Abilitato solo se cveId è non vuoto.
 * retry: false perché 404 è uno stato valido (CVE non rilevata).
 */
export function useCveDetail(cveId: string): UseQueryResult<CveDetail> {
  return useQuery({
    queryKey: cveKeys.detail(cveId),
    queryFn: () => fetchCveDetail(cveId),
    enabled: cveId.length > 0,
    retry: false,
  });
}
